var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeviceSmartphone = function SvgDeviceSmartphone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 19v26h14V19H25zm0-2h14a2 2 0 0 1 2 2v26a2 2 0 0 1-2 2H25a2 2 0 0 1-2-2V19a2 2 0 0 1 2-2zm-2 24v-2h18v2H23zm9 3a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"
  })));
};
export default SvgDeviceSmartphone;